import { FC, ReactElement } from 'react';

import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import styles from './HideForFloadtingBetBoard.module.css';

interface HideForFloatingBetBoardProps {
  children: ReactElement;
  open: boolean;
}

export const HideForFloatingBetBoard: FC<HideForFloatingBetBoardProps> = ({ children, open }): ReactElement => {
  const isOpen = useModifiers(styles, 'footer', {
    open,
  });

  return <span className={`${styles.footer} ${isOpen}`}>{children}</span>;
};
